import { render, staticRenderFns } from "./u-mobile-nav-basic.vue?vue&type=template&id=e8ba83d0&scoped=true&"
import script from "./u-mobile-nav-basic.vue?vue&type=script&lang=js&"
export * from "./u-mobile-nav-basic.vue?vue&type=script&lang=js&"
import style0 from "./u-mobile-nav-basic.vue?vue&type=style&index=0&id=e8ba83d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ba83d0",
  null
  
)

export default component.exports